import { useEffect, useState } from 'react'
import { LANGUAGE_EN } from '@edulastic/constants/const/languages'
import { getAvailableLanguageKeysInTest } from '../../../utils/helpers'
import { filterAndOrderByLanguageOptions } from '../../../../author/questionUtils'

const useTestLanguageTab = ({
  test,
  currentSettingsId,
  setLanguage,
  setLanguageTabs,
  isDocBased,
}) => {
  const [popoverVisible, setPopoverVisible] = useState(false)

  const [selectedLanguages, setSelectedLanguages] = useState([])

  // On mount, set the selected languages and the current language
  useEffect(() => {
    if (isDocBased) {
      setSelectedLanguages([LANGUAGE_EN])
      setLanguageTabs([LANGUAGE_EN])
      setLanguage({
        languageCode: LANGUAGE_EN,
        isTestSettingsView: true,
      })
    } else {
      const availableLanguageCodesInTest = getAvailableLanguageKeysInTest(test)

      // if test has no languages set, set default tabs to English
      const languageCodes =
        availableLanguageCodesInTest?.length > 0
          ? availableLanguageCodesInTest
          : [LANGUAGE_EN]

      const sortedLanguageTabs = filterAndOrderByLanguageOptions(languageCodes)

      setSelectedLanguages([...sortedLanguageTabs])
      setLanguageTabs([...sortedLanguageTabs])
      setLanguage({
        languageCode: sortedLanguageTabs[0] || LANGUAGE_EN,
        isTestSettingsView: true,
      })
    }
  }, [currentSettingsId, isDocBased])

  // On change, update the selected languages
  const handleSelectedLang = (checked, lang) => {
    if (checked) {
      setSelectedLanguages(
        filterAndOrderByLanguageOptions([...selectedLanguages, lang])
      )
    } else {
      setSelectedLanguages(
        filterAndOrderByLanguageOptions(
          selectedLanguages.filter((l) => l !== lang)
        )
      )
    }
  }

  const handleSaveLanguage = () => {
    const sortedLanguageTabs = filterAndOrderByLanguageOptions([
      ...selectedLanguages,
    ])

    setSelectedLanguages([...sortedLanguageTabs])
    setLanguageTabs([...sortedLanguageTabs])
    setLanguage({
      languageCode: sortedLanguageTabs[0] || LANGUAGE_EN,
      isSavingLanguageTabs: true,
      isTestSettingsView: true,
    })
  }

  const handleChangeLanguage = ({ key }) => {
    setLanguage({ languageCode: key, isTestSettingsView: true })
  }

  return {
    popoverVisible,
    setPopoverVisible,
    selectedLanguages,
    setSelectedLanguages,
    setLanguage,
    handleSelectedLang,
    handleSaveLanguage,
    handleChangeLanguage,
  }
}
export default useTestLanguageTab
